var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaugeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.17 22.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #2b2b2b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.59,21.09c-.06,0-.08-.04-.09-.05L1.02,1.15s-.03-.05,0-.1c.03-.05,.07-.05,.09-.05H24.07s.06,0,.09,.05c.03,.05,0,.09,0,.1L12.68,21.04s-.03,.05-.09,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.51,2l-4.96,8.6-4.96,8.6L7.62,10.6,2.66,2H22.51m1.55-2H1.1C.26,0-.28,.92,.15,1.65L5.89,11.6l5.74,9.94c.21,.37,.58,.55,.96,.55s.74-.18,.96-.55l5.74-9.94L25.02,1.65c.42-.74-.11-1.65-.96-1.65h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeArrow);
export default __webpack_public_path__ + "static/media/gauge-arrow.9348ab2c9b4b2275942ec41052474c60.svg";
export { ForwardRef as ReactComponent };